import navBarHomepage from '../modules/navbar-homepage';
import searchClearForm from '../modules/search-clear-form';
import searchImageError from '../modules/search-image-error';
import searchAnalytics from '../modules/analytics/search';
let searchController = () => {
    navBarHomepage.on();
    searchClearForm.on();
    searchImageError();
    searchAnalytics();
};

export default searchController;
